export const caseStudiesData = [
  // Restaurant Chains - Multi-location operations
  {
    id: "restaurant-chain-standardization",
    category: "Restaurant Chains",
    title: "45% Cost Reduction Through Multi-Location Standardization",
    client: "Regional Restaurant Chain (12 Locations)",
    location: "Delhi NCR & Punjab",
    challenge: "A growing restaurant chain faced inconsistent service quality across locations, high operational costs, inventory wastage, and difficulty maintaining brand standards.",
    solution: [
      "Standardized SOPs across all 12 locations for consistency",
      "Implemented centralized procurement system with vendor management",
      "Deployed cloud-based POS system with real-time inventory tracking",
      "Created comprehensive training program for all staff levels",
      "Set up quality control checkpoints and mystery shopper program",
      "Optimized supply chain with demand forecasting"
    ],
    results: {
      operatingCosts: "-45%",
      serviceTime: "-35%",
      foodWaste: "-52%",
      brandConsistency: "+88%"
    },
    timeline: "6 months",
    services: ["Process & Productivity Improvement", "Purchase Management", "Staff Training", "POS Integration"],
    testimonial: {
      quote: "Terces gave us the systems needed to scale properly. We've opened 3 more locations since implementing their solutions, with much better unit economics.",
      author: "Vikram Singh",
      position: "Managing Director"
    },
    image: "https://images.unsplash.com/photo-1552566626-52f8b828add9?w=800&h=600&fit=crop"
  },
  {
    id: "restaurant-chain-expansion",
    category: "Restaurant Chains",
    title: "Seamless Expansion: 5 to 15 Locations in 18 Months",
    client: "Fast Casual Restaurant Chain",
    location: "Maharashtra & Karnataka",
    challenge: "A successful 5-location chain wanted to expand rapidly but lacked the operational infrastructure, standardized processes, and supply chain management needed for multi-city growth.",
    solution: [
      "Developed scalable operational framework and franchise-ready systems",
      "Created central kitchen commissary for consistency across locations",
      "Implemented enterprise POS with multi-location reporting",
      "Built comprehensive franchise operations manual",
      "Set up centralized purchasing with regional vendor networks",
      "Developed training academy for new location onboarding"
    ],
    results: {
      locations: "5 → 15",
      revenueGrowth: "+280%",
      setupTime: "-60%",
      qualityScore: "+42%"
    },
    timeline: "18 months",
    services: ["Process & Productivity Improvement", "Operations Planning", "Staff Training", "Purchase Management"],
    testimonial: {
      quote: "We tripled our footprint while maintaining quality. Terces built us a system that scales.",
      author: "Anjali Kapoor",
      position: "CEO & Founder"
    },
    image: "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=800&h=600&fit=crop"
  },
  {
    id: "restaurant-chain-digital-transformation",
    category: "Restaurant Chains",
    title: "Digital Transformation Across 20 Locations",
    client: "Established Restaurant Chain",
    location: "Pan-India (20 Locations)",
    challenge: "A traditional restaurant chain with 20 locations struggled with outdated technology, no online ordering, fragmented customer data, and inability to compete with digitally-native brands.",
    solution: [
      "Implemented unified digital ordering platform across all locations",
      "Deployed centralized CRM system with 360-degree customer view",
      "Launched mobile app with loyalty program and rewards",
      "Integrated all locations with major delivery platforms",
      "Set up business intelligence dashboard for real-time insights",
      "Created digital marketing strategy with location-based campaigns"
    ],
    results: {
      onlineOrders: "0% → 42%",
      customerData: "20K unified",
      appDownloads: "50K+",
      avgOrderValue: "+38%"
    },
    timeline: "5 months",
    services: ["Digital Marketing", "POS Integration", "CRM", "Website Design"],
    testimonial: {
      quote: "Moving from pen-and-paper to digital across 20 locations seemed impossible. Terces made it happen seamlessly.",
      author: "Ramesh Gupta",
      position: "Operations Director"
    },
    image: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=800&h=600&fit=crop"
  },
  {
    id: "restaurant-chain-menu-optimization",
    category: "Restaurant Chains",
    title: "Centralized Menu Engineering Across Chain",
    client: "Multi-Cuisine Restaurant Chain (8 Locations)",
    location: "Gujarat & Rajasthan",
    challenge: "Each location had developed its own menu variations, leading to supply chain complexity, training difficulties, inconsistent customer experience, and poor margins.",
    solution: [
      "Conducted comprehensive menu analysis across all locations",
      "Standardized core menu while allowing regional customization",
      "Optimized ingredient overlap to reduce SKU count by 40%",
      "Implemented menu costing system with profit tracking",
      "Created seasonal menu rotation framework",
      "Trained kitchen teams on standardized recipes and plating"
    ],
    results: {
      profitMargin: "+32%",
      supplySKUs: "-40%",
      prepTime: "-25%",
      customerSat: "+35%"
    },
    timeline: "4 months",
    services: ["Menu Management", "Kitchen Operations", "Purchase Management", "Staff Training"],
    testimonial: {
      quote: "Streamlining our menu across locations cut costs dramatically while improving customer satisfaction. Best of both worlds.",
      author: "Pooja Shah",
      position: "Co-Owner"
    },
    image: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800&h=600&fit=crop"
  },
  {
    id: "restaurant-chain-staff-retention",
    category: "Restaurant Chains",
    title: "70% Reduction in Staff Turnover Chain-Wide",
    client: "QSR Chain (10 Locations)",
    location: "Tamil Nadu & Andhra Pradesh",
    challenge: "Chronic high turnover (120% annually) across all locations led to constant training costs, inconsistent service, and operational chaos. Staff morale was at an all-time low.",
    solution: [
      "Redesigned compensation structure with performance incentives",
      "Created career progression framework with clear advancement paths",
      "Implemented comprehensive onboarding and training program",
      "Set up employee recognition and rewards system",
      "Improved scheduling system for better work-life balance",
      "Established regular feedback mechanisms and grievance resolution"
    ],
    results: {
      turnoverRate: "120% → 35%",
      trainingCosts: "-65%",
      serviceQuality: "+55%",
      staffSatisfaction: "+82%"
    },
    timeline: "7 months",
    services: ["Staff Training", "Process & Productivity Improvement", "Operations Planning"],
    testimonial: {
      quote: "Our staff are now our biggest asset instead of our biggest problem. The cultural shift has been remarkable.",
      author: "Suresh Kumar",
      position: "Regional Manager"
    },
    image: "https://images.unsplash.com/photo-1556761175-b413da4baf72?w=800&h=600&fit=crop"
  },

  // Independent Operators - Single-unit excellence
  {
    id: "independent-fine-dining",
    category: "Independent Operators",
    title: "Fine Dining Excellence: 35% Revenue Increase",
    client: "Upscale Independent Restaurant",
    location: "Mumbai, Maharashtra",
    challenge: "A premium independent restaurant was experiencing declining revenues despite high foot traffic. Extensive menu led to high food costs, slow service, and kitchen inefficiencies.",
    solution: [
      "Conducted comprehensive menu analysis and identified low-margin items",
      "Redesigned menu with focus on high-profit signature dishes",
      "Implemented dynamic pricing strategy based on demand",
      "Streamlined kitchen operations with optimized prep workflows",
      "Trained staff on upselling techniques for premium items",
      "Enhanced ambiance and customer experience touchpoints"
    ],
    results: {
      revenue: "+35%",
      foodCost: "-18%",
      tableTime: "-22%",
      customerSat: "+28%"
    },
    timeline: "3 months",
    services: ["Menu Management", "Kitchen Operations", "Staff Training"],
    testimonial: {
      quote: "Terces transformed our operations completely. The menu engineering alone paid for itself within the first month.",
      author: "Rajesh Mehta",
      position: "Owner & Head Chef"
    },
    image: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800&h=600&fit=crop"
  },
  {
    id: "independent-cafe-transformation",
    category: "Independent Operators",
    title: "Complete Cafe Brand Transformation & Digital Presence",
    client: "Independent Specialty Cafe",
    location: "Pune, Maharashtra",
    challenge: "A beloved local cafe struggled with outdated branding, no online presence, declining younger customer base, and no digital ordering capabilities.",
    solution: [
      "Developed modern brand identity while preserving heritage elements",
      "Created mobile-responsive website with online ordering integration",
      "Launched Instagram and Facebook presence with content strategy",
      "Implemented loyalty program via CRM system",
      "Designed attractive interior updates on budget",
      "Created influencer partnership program for local food bloggers"
    ],
    results: {
      footTraffic: "+78%",
      onlineOrders: "0 → 35%",
      socialFollowers: "200 → 12K",
      youngDemographic: "+145%"
    },
    timeline: "3 months",
    services: ["Branding & Marketing", "Website Design", "Digital Marketing", "CRM"],
    testimonial: {
      quote: "We were skeptical about 'going digital' but Terces made it seamless. Our cafe is busier than ever.",
      author: "Anita Desai",
      position: "Owner"
    },
    image: "https://images.unsplash.com/photo-1554118811-1e0d58224f24?w=800&h=600&fit=crop"
  },
  {
    id: "independent-turnaround",
    category: "Independent Operators",
    title: "From Near-Closure to Thriving: 125% Revenue Growth",
    client: "Family-Style Independent Restaurant",
    location: "Ahmedabad, Gujarat",
    challenge: "A 15-year-old independent restaurant faced declining sales, outdated systems, poor online reviews, unmotivated staff, mounting debt, and was considering closure.",
    solution: [
      "Conducted full operational audit and created turnaround plan",
      "Refreshed menu with focus on signature family recipes",
      "Modernized interior with cost-effective updates",
      "Implemented new POS system with inventory management",
      "Launched comprehensive digital marketing campaign",
      "Retrained entire staff with focus on service excellence"
    ],
    results: {
      revenue: "+125%",
      profitMargin: "Negative → 22%",
      onlineRating: "2.8 → 4.6",
      staffTurnover: "-70%"
    },
    timeline: "8 months",
    services: ["Full Service Package - All Services"],
    testimonial: {
      quote: "We were on the verge of shutting down. Terces didn't just save our restaurant—they revived our passion for it.",
      author: "Amit & Neha Patel",
      position: "Owners"
    },
    image: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=800&h=600&fit=crop"
  },
  {
    id: "independent-niche-positioning",
    category: "Independent Operators",
    title: "Niche Positioning Strategy: Vegan Fine Dining Success",
    client: "Independent Vegan Restaurant",
    location: "Bangalore, Karnataka",
    challenge: "New vegan restaurant struggled to attract customers beyond the small vegan community. Perceived as expensive and niche, with low awareness and poor positioning.",
    solution: [
      "Repositioned as 'plant-forward fine dining' rather than 'vegan'",
      "Created experiential tasting menu to showcase culinary innovation",
      "Launched PR campaign highlighting chef's credentials and philosophy",
      "Partnered with wellness influencers and lifestyle brands",
      "Designed Instagram-worthy plating and ambiance",
      "Implemented dynamic pricing for different service times"
    ],
    results: {
      revenue: "+215%",
      nonVeganGuests: "15% → 68%",
      avgCheck: "+52%",
      mediaFeatures: "25+ outlets"
    },
    timeline: "5 months",
    services: ["Branding & Marketing", "Menu Management", "Digital Marketing"],
    testimonial: {
      quote: "Terces helped us break out of the vegan niche and become a destination for all food lovers. We're fully booked weeks in advance.",
      author: "Meera Krishnan",
      position: "Owner & Chef"
    },
    image: "https://images.unsplash.com/photo-1544148103-0773bf10d330?w=800&h=600&fit=crop"
  },

  // Franchise Outlets - Standardized success
  {
    id: "franchise-system-development",
    category: "Franchise Outlets",
    title: "Franchise System Development: 0 to 8 Franchisees",
    client: "Regional Restaurant Brand",
    location: "Kerala",
    challenge: "Successful single-location owner wanted to franchise but lacked systems, documentation, processes, and franchise-ready operations needed for replication.",
    solution: [
      "Developed comprehensive franchise operations manual",
      "Created standardized training program for franchisees and staff",
      "Built franchise financial models and unit economics documentation",
      "Designed scalable supply chain and vendor network",
      "Implemented cloud-based systems for centralized oversight",
      "Created franchise marketing and brand guidelines"
    ],
    results: {
      franchisesSold: "8 units",
      setupTime: "45 days avg",
      franchiseeROI: "18 months avg",
      brandConsistency: "95% score"
    },
    timeline: "10 months",
    services: ["Operations Planning", "Process & Productivity Improvement", "Staff Training", "Purchase Management"],
    testimonial: {
      quote: "Terces turned my single restaurant into a franchise-ready system. All 8 franchisees are profitable.",
      author: "Thomas Mathew",
      position: "Founder & Franchisor"
    },
    image: "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=800&h=600&fit=crop"
  },
  {
    id: "franchise-performance-turnaround",
    category: "Franchise Outlets",
    title: "Underperforming Franchisee Turnaround",
    client: "QSR Franchise Outlet",
    location: "Jaipur, Rajasthan",
    challenge: "Franchise outlet was consistently ranking last in the network with poor sales, bad reviews, operational violations, and franchisor considering termination.",
    solution: [
      "Conducted operational audit and identified core issues",
      "Replaced underperforming manager and retrained staff",
      "Implemented strict adherence to brand standards and SOPs",
      "Fixed inventory management and reduced wastage",
      "Launched local area marketing campaigns",
      "Improved customer service and response to complaints"
    ],
    results: {
      salesRanking: "Last → Top 3",
      revenue: "+165%",
      onlineRating: "2.9 → 4.5",
      operationsScore: "45% → 96%"
    },
    timeline: "4 months",
    services: ["Operations Planning", "Staff Training", "Digital Marketing", "Process & Productivity Improvement"],
    testimonial: {
      quote: "From termination notice to top performer. Terces saved our franchise investment and our reputation.",
      author: "Karan Malhotra",
      position: "Franchisee Owner"
    },
    image: "https://images.unsplash.com/photo-1552566626-52f8b828add9?w=800&h=600&fit=crop"
  },
  {
    id: "franchise-multi-unit-success",
    category: "Franchise Outlets",
    title: "Multi-Unit Franchisee: 1 to 5 Locations",
    client: "Multi-Unit Franchise Owner",
    location: "Hyderabad, Telangana",
    challenge: "Successful single-unit franchisee wanted to open multiple locations but lacked systems to manage multiple outlets while maintaining quality and profitability.",
    solution: [
      "Developed multi-unit management structure and reporting systems",
      "Implemented area manager role with clear responsibilities",
      "Created centralized procurement for all locations",
      "Set up performance dashboards for real-time monitoring",
      "Established quality assurance protocols and regular audits",
      "Built strong general manager pipeline and training"
    ],
    results: {
      locations: "1 → 5",
      combinedRevenue: "+420%",
      avgUnitMargin: "+8%",
      staffRetention: "+45%"
    },
    timeline: "14 months",
    services: ["Operations Planning", "Process & Productivity Improvement", "Staff Training", "POS Integration"],
    testimonial: {
      quote: "Terces gave me the confidence and systems to scale beyond one location. Now I manage five profitably.",
      author: "Deepak Reddy",
      position: "Multi-Unit Franchisee"
    },
    image: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=800&h=600&fit=crop"
  },
  {
    id: "franchise-new-territory",
    category: "Franchise Outlets",
    title: "New Territory Launch: First Franchise in Northeast",
    client: "National QSR Franchise",
    location: "Guwahati, Assam",
    challenge: "National franchise brand's first location in Northeast India faced unique challenges: supply chain logistics, local taste preferences, and building brand awareness in new market.",
    solution: [
      "Adapted supply chain with regional vendors for fresh ingredients",
      "Modified menu offerings based on local taste testing",
      "Created region-specific marketing campaign",
      "Hired and trained local staff with cultural sensitivity",
      "Built community partnerships and local PR strategy",
      "Set up efficient logistics for centrally-sourced items"
    ],
    results: {
      salesvsProjection: "+85%",
      localIngredients: "40% sourced",
      brandAwareness: "15% → 62%",
      customerSat: "4.6/5 avg"
    },
    timeline: "6 months",
    services: ["Operations Planning", "Digital Marketing", "Purchase Management", "Staff Training"],
    testimonial: {
      quote: "Launching in a completely new region was daunting. Terces understood local nuances while maintaining brand standards.",
      author: "Ritu Sharma",
      position: "Franchisee Owner"
    },
    image: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800&h=600&fit=crop"
  },

  // Cloud Kitchens - Delivery-focused dining
  {
    id: "cloud-kitchen-launch",
    category: "Cloud Kitchens",
    title: "300% Order Growth via Digital Marketing & Delivery",
    client: "Multi-Cuisine Cloud Kitchen",
    location: "Bangalore, Karnataka",
    challenge: "Newly launched cloud kitchen struggled with low visibility on delivery platforms, inconsistent order volumes, poor ratings due to delivery delays, and packaging issues.",
    solution: [
      "Developed comprehensive digital marketing strategy across platforms",
      "Optimized menu listings with professional photography",
      "Implemented CRM system to track customer preferences",
      "Redesigned packaging for better presentation and temperature retention",
      "Set up automated customer feedback system",
      "Integrated POS with delivery platforms for real-time tracking"
    ],
    results: {
      orders: "+300%",
      rating: "3.2 → 4.7",
      repeatCustomers: "+85%",
      avgOrderValue: "+42%"
    },
    timeline: "4 months",
    services: ["Digital Marketing", "CRM", "POS Integration", "Operations"],
    testimonial: {
      quote: "We went from struggling to survive to becoming a top-rated kitchen in our area.",
      author: "Priya Sharma",
      position: "Founder"
    },
    image: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=800&h=600&fit=crop"
  },
  {
    id: "cloud-kitchen-multi-brand",
    category: "Cloud Kitchens",
    title: "Multi-Brand Cloud Kitchen: 1 to 5 Virtual Brands",
    client: "Cloud Kitchen Operator",
    location: "Gurgaon, Haryana",
    challenge: "Single-brand cloud kitchen had excess capacity and wanted to maximize kitchen utilization with multiple virtual brands without operational chaos.",
    solution: [
      "Analyzed delivery data to identify underserved cuisine gaps",
      "Developed 4 complementary virtual brands with shared ingredients",
      "Created distinct brand identities and menu positioning",
      "Optimized kitchen workflow for parallel brand operations",
      "Implemented separate digital marketing for each brand",
      "Set up unified operations dashboard for all brands"
    ],
    results: {
      brands: "1 → 5",
      kitchenUtilization: "+240%",
      revenue: "+380%",
      operatingMargin: "+15%"
    },
    timeline: "5 months",
    services: ["Operations Planning", "Branding & Marketing", "Digital Marketing", "Menu Management"],
    testimonial: {
      quote: "Five profitable brands from one kitchen. Terces showed us how to maximize our assets intelligently.",
      author: "Arjun Malhotra",
      position: "Founder"
    },
    image: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=800&h=600&fit=crop"
  },
  {
    id: "cloud-kitchen-profitability",
    category: "Cloud Kitchens",
    title: "From Break-Even to 28% Profit Margins",
    client: "Cloud Kitchen (Biryani Specialist)",
    location: "Chennai, Tamil Nadu",
    challenge: "Cloud kitchen was generating high order volume but barely breaking even due to thin margins, high commission costs, and operational inefficiencies.",
    solution: [
      "Conducted detailed cost analysis and pricing optimization",
      "Negotiated better commission rates with delivery platforms",
      "Implemented portion control and waste reduction systems",
      "Optimized packaging costs without compromising quality",
      "Increased average order value through strategic menu design",
      "Built direct ordering channel to reduce platform dependency"
    ],
    results: {
      profitMargin: "2% → 28%",
      directOrders: "0% → 25%",
      foodCost: "-22%",
      avgOrderValue: "+45%"
    },
    timeline: "3 months",
    services: ["Menu Management", "Website Design", "Purchase Management", "Operations"],
    testimonial: {
      quote: "We were working hard but not making money. Terces helped us find profit in every order.",
      author: "Lakshmi Narayan",
      position: "Co-Founder"
    },
    image: "https://images.unsplash.com/photo-1563379091339-03b21ab4a4f8?w=800&h=600&fit=crop"
  },
  {
    id: "cloud-kitchen-expansion",
    category: "Cloud Kitchens",
    title: "Strategic Multi-Location Expansion: 1 to 7 Kitchens",
    client: "Cloud Kitchen Brand",
    location: "Mumbai Metro Area",
    challenge: "Successful cloud kitchen wanted to expand across Mumbai but needed strategy for location selection, maintaining quality, and managing distributed operations.",
    solution: [
      "Analyzed delivery data to identify optimal location zones",
      "Created standardized kitchen setup and equipment specifications",
      "Implemented central inventory management across all locations",
      "Built operations manual for consistent execution",
      "Set up zone-based marketing and localized promotions",
      "Deployed centralized monitoring and support system"
    ],
    results: {
      locations: "1 → 7",
      coverageArea: "+480%",
      avgDeliveryTime: "-12 min",
      brandRevenue: "+620%"
    },
    timeline: "8 months",
    services: ["Operations Planning", "Process & Productivity Improvement", "Purchase Management", "Digital Marketing"],
    testimonial: {
      quote: "From one kitchen to seven without losing quality or control. Strategic expansion done right.",
      author: "Rohan Desai",
      position: "Founder & CEO"
    },
    image: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=800&h=600&fit=crop"
  },

  // Pubs & Breweries
  {
    id: "brewery-launch",
    category: "Pubs & Breweries",
    title: "Microbrewery Launch: Sold Out in 6 Weeks",
    client: "New Microbrewery & Taproom",
    location: "Pune, Maharashtra",
    challenge: "New microbrewery entering competitive market needed to build awareness, establish brand identity, create buzz, and achieve fast ramp-up to profitability.",
    solution: [
      "Developed unique brand positioning around local ingredients",
      "Created experiential taproom design with brewery tours",
      "Launched pre-opening social media campaign and beer tastings",
      "Designed food menu to complement beer offerings",
      "Built partnerships with local restaurants for distribution",
      "Implemented loyalty program for taproom regulars"
    ],
    results: {
      openingWeek: "Capacity crowds",
      beerDistribution: "25+ outlets",
      socialFollowers: "15K pre-launch",
      monthlyRevenue: "Target in Week 6"
    },
    timeline: "4 months",
    services: ["Branding & Marketing", "Digital Marketing", "Menu Management", "Operations"],
    testimonial: {
      quote: "We went from unknown to the hottest brewery in Pune. The pre-launch strategy was genius.",
      author: "Aditya Kulkarni",
      position: "Founder & Brewmaster"
    },
    image: "https://images.unsplash.com/photo-1559339352-11d035aa65de?w=800&h=600&fit=crop"
  },
  {
    id: "pub-revitalization",
    category: "Pubs & Breweries",
    title: "Legacy Pub Revitalization: 85% Revenue Increase",
    client: "Established Pub (12 Years Old)",
    location: "Bangalore, Karnataka",
    challenge: "Once-popular pub was losing customers to newer competition, had dated interiors, stale menu, and reputation as 'past its prime' among younger demographics.",
    solution: [
      "Redesigned interior with modern industrial aesthetic",
      "Refreshed menu with contemporary pub fare and craft cocktails",
      "Launched 'Heritage Meets Modern' rebranding campaign",
      "Introduced live music and events calendar",
      "Created Instagram-worthy moments throughout venue",
      "Implemented dynamic pricing and happy hour strategy"
    ],
    results: {
      revenue: "+85%",
      avgAge: "42 → 32 years",
      weekendBookings: "Full 3 weeks out",
      socialEngagement: "+320%"
    },
    timeline: "5 months",
    services: ["Branding & Marketing", "Menu Management", "Digital Marketing", "Operations"],
    testimonial: {
      quote: "Terces breathed new life into our pub. We're packed with a whole new generation while keeping our loyal regulars.",
      author: "Sunil D'Souza",
      position: "Owner"
    },
    image: "https://images.unsplash.com/photo-1572116469696-31de0f17cc34?w=800&h=600&fit=crop"
  },
  {
    id: "brewery-food-program",
    category: "Pubs & Breweries",
    title: "Food Program Transformation: 40% Revenue Increase",
    client: "Microbrewery with Basic Food",
    location: "Gurgaon, Haryana",
    challenge: "Successful brewery with great beer but weak food program. Customers visited once but didn't return for dining. Food sales were only 20% of revenue.",
    solution: [
      "Developed beer-pairing focused food menu",
      "Hired experienced chef and upgraded kitchen equipment",
      "Created seasonal menu aligned with beer releases",
      "Trained staff on food and beer pairing recommendations",
      "Launched food-focused marketing campaigns",
      "Introduced brewery brunch and food events"
    ],
    results: {
      foodRevenue: "20% → 48%",
      avgCheck: "+40%",
      visitFrequency: "+65%",
      foodRating: "3.1 → 4.4"
    },
    timeline: "4 months",
    services: ["Menu Management", "Kitchen Operations", "Staff Training", "Digital Marketing"],
    testimonial: {
      quote: "We were known for beer, now we're a destination for the complete experience. Food revenue nearly tripled.",
      author: "Nisha Verma",
      position: "Co-Owner"
    },
    image: "https://images.unsplash.com/photo-1559339352-11d035aa65de?w=800&h=600&fit=crop"
  },
  {
    id: "pub-chain-standardization",
    category: "Pubs & Breweries",
    title: "Pub Chain Standardization Across 6 Locations",
    client: "Regional Pub Chain",
    location: "Delhi NCR (6 Locations)",
    challenge: "Pub chain had inconsistent experiences across locations with different menus, varying quality, no brand identity, and inefficient operations at each outlet.",
    solution: [
      "Created core standardized menu with local customization options",
      "Developed unified brand identity and design standards",
      "Implemented central recipe management and training",
      "Set up centralized beverage procurement for better margins",
      "Created operations manual and quality standards",
      "Built cross-location loyalty program"
    ],
    results: {
      brandConsistency: "+78%",
      beverageCost: "-15%",
      customerRetention: "+52%",
      avgRevenue: "+35%"
    },
    timeline: "6 months",
    services: ["Process & Productivity Improvement", "Menu Management", "Purchase Management", "Staff Training"],
    testimonial: {
      quote: "Each location was doing its own thing. Now we have a real brand that customers recognize and trust.",
      author: "Kabir Mehra",
      position: "Managing Partner"
    },
    image: "https://images.unsplash.com/photo-1572116469696-31de0f17cc34?w=800&h=600&fit=crop"
  },
  {
    id: "brewery-distribution",
    category: "Pubs & Breweries",
    title: "Brewery Distribution Expansion: Taproom to Retail",
    client: "Microbrewery",
    location: "Mumbai, Maharashtra",
    challenge: "Successful taproom wanted to expand beyond on-premise sales into bottled distribution but lacked production capacity, regulatory knowledge, and distribution network.",
    solution: [
      "Developed production scale-up plan and equipment investment",
      "Navigated licensing and regulatory requirements for bottling",
      "Created retail brand identity and packaging design",
      "Built distribution network with key retail partners",
      "Launched retail-focused marketing campaign",
      "Implemented production planning and inventory management"
    ],
    results: {
      distributionPoints: "1 → 150+",
      revenue: "+180%",
      brandAwareness: "+240%",
      productionVolume: "4x increase"
    },
    timeline: "9 months",
    services: ["Operations Planning", "Branding & Marketing", "Purchase Management", "Digital Marketing"],
    testimonial: {
      quote: "From local taproom to bottles in stores across Mumbai. Terces helped us scale production and distribution.",
      author: "Vikram Chatterjee",
      position: "Founder"
    },
    image: "https://images.unsplash.com/photo-1559339352-11d035aa65de?w=800&h=600&fit=crop"
  }
];

// Category filters
export const caseStudyCategories = [
  "All",
  "Restaurant Chains",
  "Independent Operators",
  "Franchise Outlets",
  "Cloud Kitchens",
  "Pubs & Breweries"
];

// Service filters
export const caseStudyServices = [
  "All Services",
  "Menu Management",
  "Digital Marketing",
  "Process & Productivity Improvement",
  "CRM",
  "Staff Training",
  "POS Integration",
  "Website Design",
  "Branding & Marketing"
];
